import { render, staticRenderFns } from "./lyhHeader.vue?vue&type=template&id=aa996d88&scoped=true"
import script from "./lyhHeader.vue?vue&type=script&lang=js"
export * from "./lyhHeader.vue?vue&type=script&lang=js"
import style0 from "./lyhHeader.vue?vue&type=style&index=0&id=aa996d88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa996d88",
  null
  
)

export default component.exports